import React from 'react'
import { Widget, Divider } from '@duik/it'
import styled from '@emotion/styled'
import { ModalButton } from './ModalButton'

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(19, 24, 32, 0.6);
  display: flex;
  justify-content: center;
  z-index: 1;
  align-items: center;
`

const WidgetWrapper = styled.div`
  max-width: 830px;
  height: calc(100vh - 100px);
  max-height: 640px;
  width: 100%;
  background-color: white;
  border-radius: 5px;
`

const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 74px;
`

const Heading = styled.h3`
  margin: 0 30px;
  color: #3e3f42;
  font-size: 18px;
  font-weight: medium;
`

const AltHeading = styled.p`
  margin: 0 30px;
  color: #3e3f42;
  font-size: 16px;
`

const ChildWrapper = styled.div`
  height: 100%;
  height: calc(100vh - 175px);
  overflow: scroll;
  margin: 0 30px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`

const ButtonContainer = styled.div`
  width: 176px;
`

const EditButtonContainer = styled.div`
  width: auto;
  margin-right: 20px;
`

const ButtonWrapper = styled.div`
  display: flex;
  margin-right: 30px;
  align-items: center;
`

const EditButtonText = styled.p`
  color: #289c91;
  font-size: 16px;
  :hover {
    cursor: pointer;
    color: #fa2d35;
  }
`

type Props = {
  title: string
  subTitle: string
  children?: any
  handleOkClick: () => void
  handleEditClick: () => void
}

const LargeViewModal = ({ title, subTitle, children, handleOkClick, handleEditClick }: Props) => (
  <Container>
    <WidgetWrapper>
      <Widget>
        <HeadingWrapper>
          <div>
            <Heading>{title}</Heading>
            <AltHeading>{subTitle}</AltHeading>
          </div>
          <ButtonWrapper>
            <EditButtonContainer>
              <EditButtonText onClick={handleEditClick}>Edit</EditButtonText>
            </EditButtonContainer>
            <ButtonContainer>
              <ModalButton name="Ok" onClick={handleOkClick} />
            </ButtonContainer>
          </ButtonWrapper>
        </HeadingWrapper>
        <Divider />
      </Widget>
      <ChildWrapper>{children}</ChildWrapper>
    </WidgetWrapper>
  </Container>
)

export default LargeViewModal
